// Helper function to get color variant
const getColorVariant = (theme, color) => {
  return theme.palette[color] || theme.palette.primary // Fallback to primary if color not found
}

export default getColorVariant
